{
  "familyId": "SWW-VT-STERK",
  "questions": [
    {
      "id": "SWW-VT-STERK-001",
      "familyId": "SWW-VT-STERK",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_sterk",
      "questionType": "multiple_choice",
      "question": "De kinderen ... gisteren in het zwembad. (zwemmen)",
      "options": ["zwommen", "zwemden", "zwemmen", "gezwommen"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "verbTable", "data": { "verb": "zwemmen", "forms": { "infinitive": "zwemmen", "presentSingular": "zwem", "pastSingular": "zwom", "pastPlural": "zwommen", "pastParticiple": "gezwommen" }, "highlight": "pastPlural", "label": "Sterk werkwoord: zwemmen" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterke werkwoorden", "content": "Sterke werkwoorden veranderen van klank in de verleden tijd. Ze krijgen GEEN -te of -de. Voorbeeld: zwemmen → zwom (enkelvoud) / zwommen (meervoud).", "icon": "lightbulb" } },
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "zwemmen", "forms": { "infinitive": "zwemmen", "presentSingular": "zwem", "pastSingular": "zwom", "pastPlural": "zwommen", "pastParticiple": "gezwommen" }, "highlight": "pastPlural" } }
      ],
      "conceptId": "vt_sterk_zwemmen",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Zwemmen' is een sterk werkwoord — de klinker verandert in de verleden tijd: e → o. 'De kinderen' is meervoud, dus je gebruikt de meervoudsvorm: zwommen. Sterke werkwoorden krijgen geen -te of -de.",
        "solutionSteps": ["Herken het signaalwoord: 'gisteren' → verleden tijd", "'Zwemmen' is een sterk werkwoord (klinkerwisseling: e → o)", "'De kinderen' is meervoud → meervoudsvorm nodig", "Verleden tijd meervoud: zwommen"],
        "distractorExplanations": {
          "0": "Goed! 'Zwommen' is de juiste verleden tijd meervoud. De klinker verandert: e → o.",
          "1": "Je dacht waarschijnlijk dat 'zwemmen' een zwak werkwoord is en -de krijgt. Maar 'zwemmen' is sterk: de klinker verandert (e → o). Het wordt zwommen, niet zwemden. Onthoud: sterke werkwoorden krijgen geen -te/-de.",
          "2": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar het signaalwoord 'gisteren' vraagt om verleden tijd. Onthoud: gisteren, vorige week, toen → verleden tijd.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'gezwommen' hoort bij een hulpwerkwoord (hebben gezwommen). Hier staat geen hulpwerkwoord, dus gebruik de gewone verleden tijd: zwommen."
        }
      }
    },
    {
      "id": "SWW-VT-STERK-002",
      "familyId": "SWW-VT-STERK",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_sterk",
      "questionType": "multiple_choice",
      "question": "De kok ... gisteren een heerlijke soep. (koken)",
      "options": ["kookte", "kokte", "koken", "gekookt"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Let op: 'koken' is GEEN sterk werkwoord", "content": "'Koken' lijkt sterk, maar is zwak. Zwakke werkwoorden krijgen -te of -de. Stam = kook, eindigt op k (kofschip) → kook + te = kookte.", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_sterk_vs_zwak_koken",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Let op: 'koken' is een zwak werkwoord, geen sterk werkwoord! De stam is 'kook' (de dubbele 'o' blijft). De stam eindigt op 'k' (kofschip) → kook + te = kookte. Bij sterke werkwoorden verandert de klinker (zoals zwemmen → zwom), maar bij 'koken' blijft de klank hetzelfde.",
        "solutionSteps": ["Herken het signaalwoord: 'gisteren' → verleden tijd", "Is 'koken' sterk of zwak? Zwak! (de klinker verandert niet)", "Stam: kook (de dubbele 'o' blijft in de stam)", "Kofschip-check: 'k' zit in kofschip → kook + te = kookte"],
        "distractorExplanations": {
          "0": "Goed! 'Koken' is zwak. Stam = kook, eindigt op k (kofschip) → kookte.",
          "1": "Je dacht waarschijnlijk dat de stam 'kok' is. Maar de stam van 'koken' is 'kook' — de dubbele 'o' blijft om de lange klank te bewaren. Onthoud: kook + te = kookte.",
          "2": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar 'gisteren' vraagt om verleden tijd. Onthoud: gisteren → verleden tijd.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'gekookt' hoort bij een hulpwerkwoord (heeft gekookt). Hier staat geen hulpwerkwoord, dus: kookte."
        }
      }
    },
    {
      "id": "SWW-VT-STERK-003",
      "familyId": "SWW-VT-STERK",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_sterk",
      "questionType": "multiple_choice",
      "question": "De timmerman ... de hele dag aan het huis. (werken → verleden tijd)",
      "options": ["werkte", "werkde", "werken", "gewerkt"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Zwak werkwoord met kofschip", "content": "'Werken' is een zwak werkwoord. De stam is 'werk'. De 'k' zit in kofschip, dus: werk + te = werkte. Niet werkde!", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_sterk_vs_zwak_werken",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Werken' is een zwak werkwoord. De stam is 'werk'. De 'k' zit in 't kofschip, dus je gebruikt -te: werk + te = werkte. Sterke werkwoorden veranderen van klinker (zoals lopen → liep), maar 'werken' doet dat niet.",
        "solutionSteps": ["Is 'werken' sterk of zwak? Zwak! (de klinker verandert niet)", "Stam: werk", "Kofschip-check: 'k' zit in 't kofschip → -te", "Verleden tijd: werk + te = werkte"],
        "distractorExplanations": {
          "0": "Goed! 'Werken' is zwak. Stam = werk, eindigt op k (kofschip) → werkte.",
          "1": "Je dacht waarschijnlijk dat het -de wordt. Maar de stam 'werk' eindigt op 'k', en 'k' zit in 't kofschip. Onthoud: kofschip → -te, anders → -de.",
          "2": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar de vraag vraagt om verleden tijd. Onthoud: kijk naar het signaalwoord of de opdracht.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'gewerkt' hoort bij een hulpwerkwoord (heeft gewerkt). Hier staat geen hulpwerkwoord, dus: werkte."
        }
      }
    },
    {
      "id": "SWW-VT-STERK-004",
      "familyId": "SWW-VT-STERK",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_sterk",
      "questionType": "multiple_choice",
      "question": "De dierenarts ... naar het zieke paard. (rijden → verleden tijd)",
      "options": ["reed", "rijdde", "rijden", "gereden"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "verbTable", "data": { "verb": "rijden", "forms": { "infinitive": "rijden", "presentSingular": "rijd", "pastSingular": "reed", "pastPlural": "reden", "pastParticiple": "gereden" }, "highlight": "pastSingular", "label": "Sterk werkwoord: rijden" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterk werkwoord: rijden", "content": "'Rijden' is een sterk werkwoord. De klinker verandert: ij → ee. Verleden tijd enkelvoud: reed. Meervoud: reden. Geen -te of -de!", "icon": "lightbulb" } },
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "rijden", "forms": { "infinitive": "rijden", "presentSingular": "rijd", "pastSingular": "reed", "pastPlural": "reden", "pastParticiple": "gereden" }, "highlight": "pastSingular" } }
      ],
      "conceptId": "vt_sterk_rijden",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Rijden' is een sterk werkwoord — de klinker verandert: ij → ee. 'De dierenarts' is enkelvoud, dus: reed. Sterke werkwoorden krijgen geen -te of -de.",
        "solutionSteps": ["Is 'rijden' sterk of zwak? Sterk! (de klinker verandert: ij → ee)", "'De dierenarts' is enkelvoud → enkelvoudsvorm nodig", "Verleden tijd enkelvoud: reed", "Check: reed — klinkerwisseling ij → ee ✓"],
        "distractorExplanations": {
          "0": "Goed! 'Rijden' is sterk. Klinkerwisseling: ij → ee. Enkelvoud: reed.",
          "1": "Je dacht waarschijnlijk dat 'rijden' een zwak werkwoord is en -de krijgt. Maar 'rijden' is sterk: de klinker verandert (ij → ee). Het wordt reed, niet rijdde. Onthoud: sterke werkwoorden veranderen van klank.",
          "2": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar de opdracht vraagt om verleden tijd. Onthoud: kijk naar de opdracht tussen haakjes.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'gereden' hoort bij een hulpwerkwoord (is gereden). Hier staat geen hulpwerkwoord, dus: reed."
        }
      }
    },
    {
      "id": "SWW-VT-STERK-005",
      "familyId": "SWW-VT-STERK",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_sterk",
      "questionType": "multiple_choice",
      "question": "De brandweerman ... de kat uit de boom. (vangen → verleden tijd)",
      "options": ["ving", "vangde", "vangtte", "gevangen"],
      "correctAnswer": 0,
      "stimulusAids": [
        { "type": "verbTable", "data": { "verb": "vangen", "forms": { "infinitive": "vangen", "presentSingular": "vang", "pastSingular": "ving", "pastPlural": "vingen", "pastParticiple": "gevangen" }, "highlight": "pastSingular", "label": "Sterk werkwoord: vangen" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterk werkwoord: vangen", "content": "'Vangen' is een sterk werkwoord. De klinker verandert: a → i. Verleden tijd enkelvoud: ving. Meervoud: vingen. Geen -te of -de!", "icon": "lightbulb" } },
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "vangen", "forms": { "infinitive": "vangen", "presentSingular": "vang", "pastSingular": "ving", "pastPlural": "vingen", "pastParticiple": "gevangen" }, "highlight": "pastSingular" } }
      ],
      "conceptId": "vt_sterk_vangen",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Vangen' is een sterk werkwoord — de klinker verandert: a → i. 'De brandweerman' is enkelvoud, dus: ving. Sterke werkwoorden krijgen geen -te of -de.",
        "solutionSteps": ["Is 'vangen' sterk of zwak? Sterk! (de klinker verandert: a → i)", "'De brandweerman' is enkelvoud → enkelvoudsvorm nodig", "Verleden tijd enkelvoud: ving", "Check: ving — klinkerwisseling a → i ✓"],
        "distractorExplanations": {
          "0": "Goed! 'Vangen' is sterk. Klinkerwisseling: a → i. Enkelvoud: ving.",
          "1": "Je dacht waarschijnlijk dat 'vangen' een zwak werkwoord is en -de krijgt. Maar 'vangen' is sterk: de klinker verandert (a → i). Het wordt ving, niet vangde. Onthoud: sterke werkwoorden veranderen van klank.",
          "2": "Je dacht waarschijnlijk dat 'vangen' -tte krijgt. Maar sterke werkwoorden krijgen helemaal geen -te of -de. De klinker verandert: vangen → ving.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'gevangen' hoort bij een hulpwerkwoord (heeft gevangen). Hier staat geen hulpwerkwoord, dus: ving."
        }
      }
    },
    {
      "id": "SWW-VT-STERK-006",
      "familyId": "SWW-VT-STERK",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_sterk",
      "questionType": "fill_in",
      "question": "Vul de juiste verleden tijd in: 'Het kind ___ gisteren van de schommel.' (vallen)",
      "correctAnswer": "viel",
      "data": {
        "acceptedAnswers": ["viel"],
        "placeholder": "verleden tijd van vallen"
      },
      "stimulusAids": [
        { "type": "verbTable", "data": { "verb": "vallen", "forms": { "infinitive": "vallen", "presentSingular": "val", "pastSingular": "viel", "pastPlural": "vielen", "pastParticiple": "gevallen" }, "highlight": "pastSingular", "label": "Sterk werkwoord: vallen" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterk werkwoord: vallen", "content": "Vallen is een sterk werkwoord: de klinker verandert (a → ie). Enkelvoud: viel. Meervoud: vielen. Geen -te of -de!", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_sterk_vallen_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Vallen' is een sterk werkwoord: de klinker verandert van a naar ie. 'Het kind' is enkelvoud, dus: viel. Sterke werkwoorden krijgen geen -te of -de.",
        "solutionSteps": [
          "Signaalwoord: 'gisteren' → verleden tijd",
          "'Vallen' is sterk: a → ie",
          "'Het kind' is enkelvoud → viel"
        ]
      }
    },
    {
      "id": "SWW-VT-STERK-007",
      "familyId": "SWW-VT-STERK",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_sterk",
      "questionType": "fill_in",
      "question": "Vul de juiste verleden tijd in: 'Wij ___ vorige week een mooi boek.' (lezen)",
      "correctAnswer": "lazen",
      "data": {
        "acceptedAnswers": ["lazen"],
        "placeholder": "verleden tijd van lezen"
      },
      "stimulusAids": [
        { "type": "verbTable", "data": { "verb": "lezen", "forms": { "infinitive": "lezen", "presentSingular": "lees", "pastSingular": "las", "pastPlural": "lazen", "pastParticiple": "gelezen" }, "highlight": "pastPlural", "label": "Sterk werkwoord: lezen" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterk werkwoord: lezen", "content": "Lezen is een sterk werkwoord: de klinker verandert (e → a). Enkelvoud: las. Meervoud: lazen.", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_sterk_lezen_fill",
      "variantIndex": 7,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Lezen' is een sterk werkwoord: de klinker verandert van e naar a. 'Wij' is meervoud, dus: lazen.",
        "solutionSteps": [
          "Signaalwoord: 'vorige week' → verleden tijd",
          "'Lezen' is sterk: e → a",
          "'Wij' is meervoud → lazen"
        ]
      }
    },
    {
      "id": "SWW-VT-STERK-008",
      "familyId": "SWW-VT-STERK",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_sterk",
      "questionType": "error_spotting",
      "question": "Zoek de fout in de werkwoordsvorm en verbeter deze.",
      "data": {
        "text": "De hond liepte gisteren door het hele park.",
        "errors": [
          {
            "word": "liepte",
            "position": 2,
            "correction": "liep",
            "explanation": "'Lopen' is een sterk werkwoord (o → ie). De verleden tijd is 'liep', niet 'liepte'. Sterke werkwoorden krijgen geen -te."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterke werkwoorden: geen -te/-de", "content": "Sterke werkwoorden veranderen van klinker in de verleden tijd en krijgen GEEN -te of -de. Lopen → liep (niet liepte). Schrijven → schreef (niet schrijfde).", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_sterk_error_liepte",
      "variantIndex": 8,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Lopen' is een sterk werkwoord: de klinker verandert (o → ie). De verleden tijd is 'liep', niet 'liepte'. Sterke werkwoorden krijgen nooit -te of -de erbij.",
        "solutionSteps": [
          "Zoek de persoonsvorm: liepte",
          "'Lopen' is een sterk werkwoord (o → ie)",
          "Sterk = geen -te/-de → liep (niet liepte)"
        ]
      }
    }
  ]
}